import React from 'react';
import { connect } from 'react-redux';
import { selector } from 'apps/services';
import { withTranslation } from 'react-i18next';
import { getText } from 'helpers/app/getText';

function NotFound() {
  const year = new Date().getFullYear();

  return (
    <div className="card my-5">
      <div className="card-body">
        <div className="abs-center wd-xl">
          <div className="text-center mb-4">
            <div className="text-lg mb-3 error-404-no">404</div>
            <p className="lead m-0">{getText('errors:NOT_FOUND_ERROR_LINE_1')}</p>
            <p>{getText('errors:NOT_FOUND_ERROR_LINE_2')}</p>
          </div>
          <div className="p-3 text-center">
            <span className="mr-2">&copy;</span>
            <span>{year}</span>
            <span className="mx-2">-</span>
            <span>Vourity</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => selector(state, false, ['authorisation', 'app', 'bookingweb']);

const mapDispatchToProps = () => {
  return {};
};

export default withTranslation('errors')(connect(mapStateToProps, mapDispatchToProps)(NotFound));
